const calculateGridMetrics = (
    gridAnchorRef,
    BOTTOM_MARGIN,
    HEADER_PAGER_BUDGET,
    ROW_HEIGHT,
    MIN_PAGE,
    MAX_PAGE,
    itens,
    innerHeight,
    setPageSize
) => {
    if (typeof setPageSize !== 'function') {
        console.warn('setPageSize inválido em calculateGridMetrics:', setPageSize);
        return;
    }

    const winH = innerHeight;

    const top =
        gridAnchorRef && gridAnchorRef.current
            ? gridAnchorRef.current.getBoundingClientRect().top
            : 0;

    const available = Math.max(50, winH - top - BOTTOM_MARGIN);
    const rowsArea = Math.max(50, available - HEADER_PAGER_BUDGET);
    const rowsFit = Math.floor(rowsArea / ROW_HEIGHT);

    const total = Array.isArray(itens) ? itens.length : 0;
    const targetRows = Math.max(MIN_PAGE, Math.min(rowsFit + 2, total, MAX_PAGE));

    setPageSize(targetRows);
};


export const paginationService = {
    calculateGridMetrics
};
